// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
        .breadcrumb {
            display: flex;
            align-items: center;
            padding: 0.5rem 1rem;
            list-style: none;
            background-color: transparent; /* Remove background */
        }

        .breadcrumb-item {
            display: inline-flex;
            align-items: center;
            margin-right: 0;
            padding-left: 0;
        }

        .breadcrumb-item::before {
            content: '';
        }

        .breadcrumb-item:not(:first-child) {
            margin-left: -1.75rem !important;
        }

        .breadcrumb-item:first-child {
            z-index: 10;
        }

        .breadcrumb-item:nth-child(1) {
            z-index: 9;
        }

        .breadcrumb-item:nth-child(2) {
            z-index: 8;
        }

        .breadcrumb-item:nth-child(3) {
            z-index: 7;
        }

        .breadcrumb-item:nth-child(4) {
            z-index: 6;
        }

        .breadcrumb-item:nth-child(5) {
            z-index: 5;
        }

        .breadcrumb-item:nth-child(6) {
            z-index: 4;
        }

        .breadcrumb-item:nth-child(7) {
            z-index: 3;
        }

        .breadcrumb-item:nth-child(8) {
            z-index: 2;
        }

        .breadcrumb-item:nth-child(9) {
            z-index: 1;
        }

        .breadcrumb-item a, .breadcrumb-item span {
            display: inline-flex;
            align-items: center;
            padding: 0.25rem 1rem;
            background-color: #fff; /* White background for pill */
            border-radius: .35rem 2rem 2rem .35rem;
            color: var(--accent); /* Dark blue text */
            font-weight: bold;
            text-transform: uppercase;
            text-decoration: none; /* Remove underline from links */
            font-size: 0.9rem;
        }

        .breadcrumb-item a {
            box-shadow: 5px 0 5px -2px #A1A1A1;
        }

        .breadcrumb-item:first-child a {
            padding-top: .5rem;
            padding-bottom: .5rem;
        }

        .breadcrumb-item.active span {
            background-color: #fff; /* Ensure active item has same background */
            color: var(--accent); /* Same color for active item */
        }

        .breadcrumb-item a:hover {
            background-color: #fff; /* Light gray on hover */
        }

        .breadcrumb-item i.fa-home {
            color: #f28c38; /* Orange color for house icon */
            font-size: 1.5em;
        }

        .breadcrumb-item a:hover span {
            color: #f28c38; /* Orange color for hover text */
        }

        /* Small devices (portrait phones, less than 576px) */
        @media (max-width: 575.98px) {
            .breadcrumb {
                flex-wrap: wrap;
                margin-bottom: .5rem;
                padding: 0.25rem .5rem;
            }

            .breadcrumb-item {
                margin-bottom: 0.1rem;
            }

            .breadcrumb-item:first-child {
                margin-left: 0;
            }

            .breadcrumb-item:first-child a {
                padding-top: .35rem;
                padding-bottom: .35rem;
            }

            .breadcrumb-item a, .breadcrumb-item span {
                padding: 0.175rem .75rem;
                border-radius: .35rem 2rem 2rem .35rem;
                font-size: .75em;
            }
        }`, "",{"version":3,"sources":["webpack://./src/app/common/component/breadcrumb/breadcrumb.component.ts"],"names":[],"mappings":";QACQ;YACI,aAAa;YACb,mBAAmB;YACnB,oBAAoB;YACpB,gBAAgB;YAChB,6BAA6B,EAAE,sBAAsB;QACzD;;QAEA;YACI,oBAAoB;YACpB,mBAAmB;YACnB,eAAe;YACf,eAAe;QACnB;;QAEA;YACI,WAAW;QACf;;QAEA;YACI,gCAAgC;QACpC;;QAEA;YACI,WAAW;QACf;;QAEA;YACI,UAAU;QACd;;QAEA;YACI,UAAU;QACd;;QAEA;YACI,UAAU;QACd;;QAEA;YACI,UAAU;QACd;;QAEA;YACI,UAAU;QACd;;QAEA;YACI,UAAU;QACd;;QAEA;YACI,UAAU;QACd;;QAEA;YACI,UAAU;QACd;;QAEA;YACI,UAAU;QACd;;QAEA;YACI,oBAAoB;YACpB,mBAAmB;YACnB,qBAAqB;YACrB,sBAAsB,EAAE,8BAA8B;YACtD,sCAAsC;YACtC,oBAAoB,EAAE,mBAAmB;YACzC,iBAAiB;YACjB,yBAAyB;YACzB,qBAAqB,EAAE,gCAAgC;YACvD,iBAAiB;QACrB;;QAEA;YAGI,kCAAkC;QACtC;;QAEA;YACI,kBAAkB;YAClB,qBAAqB;QACzB;;QAEA;YACI,sBAAsB,EAAE,2CAA2C;YACnE,oBAAoB,EAAE,+BAA+B;QACzD;;QAEA;YACI,sBAAsB,EAAE,wBAAwB;QACpD;;QAEA;YACI,cAAc,EAAE,gCAAgC;YAChD,gBAAgB;QACpB;;QAEA;YACI,cAAc,EAAE,gCAAgC;QACpD;;QAEA,qDAAqD;QACrD;YACI;gBACI,eAAe;gBACf,oBAAoB;gBACpB,sBAAsB;YAC1B;;YAEA;gBACI,qBAAqB;YACzB;;YAEA;gBACI,cAAc;YAClB;;YAEA;gBACI,mBAAmB;gBACnB,sBAAsB;YAC1B;;YAEA;gBACI,wBAAwB;gBACxB,sCAAsC;gBACtC,gBAAgB;YACpB;QACJ","sourcesContent":["\n        .breadcrumb {\n            display: flex;\n            align-items: center;\n            padding: 0.5rem 1rem;\n            list-style: none;\n            background-color: transparent; /* Remove background */\n        }\n\n        .breadcrumb-item {\n            display: inline-flex;\n            align-items: center;\n            margin-right: 0;\n            padding-left: 0;\n        }\n\n        .breadcrumb-item::before {\n            content: '';\n        }\n\n        .breadcrumb-item:not(:first-child) {\n            margin-left: -1.75rem !important;\n        }\n\n        .breadcrumb-item:first-child {\n            z-index: 10;\n        }\n\n        .breadcrumb-item:nth-child(1) {\n            z-index: 9;\n        }\n\n        .breadcrumb-item:nth-child(2) {\n            z-index: 8;\n        }\n\n        .breadcrumb-item:nth-child(3) {\n            z-index: 7;\n        }\n\n        .breadcrumb-item:nth-child(4) {\n            z-index: 6;\n        }\n\n        .breadcrumb-item:nth-child(5) {\n            z-index: 5;\n        }\n\n        .breadcrumb-item:nth-child(6) {\n            z-index: 4;\n        }\n\n        .breadcrumb-item:nth-child(7) {\n            z-index: 3;\n        }\n\n        .breadcrumb-item:nth-child(8) {\n            z-index: 2;\n        }\n\n        .breadcrumb-item:nth-child(9) {\n            z-index: 1;\n        }\n\n        .breadcrumb-item a, .breadcrumb-item span {\n            display: inline-flex;\n            align-items: center;\n            padding: 0.25rem 1rem;\n            background-color: #fff; /* White background for pill */\n            border-radius: .35rem 2rem 2rem .35rem;\n            color: var(--accent); /* Dark blue text */\n            font-weight: bold;\n            text-transform: uppercase;\n            text-decoration: none; /* Remove underline from links */\n            font-size: 0.9rem;\n        }\n\n        .breadcrumb-item a {\n            -moz-box-shadow: 5px 0 5px -2px #A1A1A1;\n            -webkit-box-shadow: 5px 0 5px -2px #A1A1A1;\n            box-shadow: 5px 0 5px -2px #A1A1A1;\n        }\n\n        .breadcrumb-item:first-child a {\n            padding-top: .5rem;\n            padding-bottom: .5rem;\n        }\n\n        .breadcrumb-item.active span {\n            background-color: #fff; /* Ensure active item has same background */\n            color: var(--accent); /* Same color for active item */\n        }\n\n        .breadcrumb-item a:hover {\n            background-color: #fff; /* Light gray on hover */\n        }\n\n        .breadcrumb-item i.fa-home {\n            color: #f28c38; /* Orange color for house icon */\n            font-size: 1.5em;\n        }\n\n        .breadcrumb-item a:hover span {\n            color: #f28c38; /* Orange color for hover text */\n        }\n\n        /* Small devices (portrait phones, less than 576px) */\n        @media (max-width: 575.98px) {\n            .breadcrumb {\n                flex-wrap: wrap;\n                margin-bottom: .5rem;\n                padding: 0.25rem .5rem;\n            }\n\n            .breadcrumb-item {\n                margin-bottom: 0.1rem;\n            }\n\n            .breadcrumb-item:first-child {\n                margin-left: 0;\n            }\n\n            .breadcrumb-item:first-child a {\n                padding-top: .35rem;\n                padding-bottom: .35rem;\n            }\n\n            .breadcrumb-item a, .breadcrumb-item span {\n                padding: 0.175rem .75rem;\n                border-radius: .35rem 2rem 2rem .35rem;\n                font-size: .75em;\n            }\n        }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
